export const TOKEN_EXPIRED_MESSAGE = "jwt expired" as const
